import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2'

@Injectable({ providedIn: 'root' })
export class AlertService {
  private confirmButtonColor = '#3085d6';
  private cancelButtonColor = '#d33';

  constructor() { }

  confirm(title: string, text: string, icon: SweetAlertIcon, confirmButtonText: string = 'Yes', cancelButtonText: string = 'No') {
    return Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCancelButton: true,
      confirmButtonColor: this.confirmButtonColor,
      cancelButtonColor: this.cancelButtonColor,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
    });
  }

  status(title: string, text: string, icon: SweetAlertIcon) {
    return Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCloseButton: true,
      confirmButtonColor: this.confirmButtonColor,
      cancelButtonColor: this.cancelButtonColor,
      timer: 5000
    });
  }
}